import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import {
  getInitialLanguagePreference,
  SUPPORTED_LANGUAGE_CODES,
} from './utils/languagePreference';

// Import translation files
import enCommon from './locales/en/common.json';
import deCommon from './locales/de/common.json';
import nlCommon from './locales/nl/common.json';
import frCommon from './locales/fr/common.json';

const resources = {
  en: {
    common: enCommon,
  },
  de: {
    common: deCommon,
  },
  nl: {
    common: nlCommon,
  },
  fr: {
    common: frCommon,
  },
};

const initialLanguage = getInitialLanguagePreference();

i18n
  // Detect user language from browser/localStorage
  .use(LanguageDetector)
  // Pass i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGE_CODES,
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    defaultNS: 'common',
    ns: ['common'],
    lng: initialLanguage || undefined,
    
    // Detection options
    detection: {
      order: ['navigator', 'htmlTag'],
      caches: [],
    },

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    react: {
      useSuspense: true,
    },
  });

export default i18n;
